import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=c25bcd4e&scoped=true&"
import script from "./Calls.vue?vue&type=script&lang=js&"
export * from "./Calls.vue?vue&type=script&lang=js&"
import style0 from "./Calls.vue?vue&type=style&index=0&id=c25bcd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25bcd4e",
  null
  
)

export default component.exports